/**
 * The values and shapes the entity modules must NOT each own a copy of.
 *
 * The shapes here are legacy WIRE shapes, read from tech-ui at the recorded vintage
 * `0e1304d` (`src/api/reimbursementsEndpoints.ts`, `src/api/types.ts`, and
 * `src/pages/components/ChargeRecordsDetailsModalForTest/interface.ts`). They are
 * hand-written interfaces, not a generated schema — there is no OpenAPI source for
 * `company-car-orchestrator`. Only the ones MORE THAN ONE entity
 * uses live here; each entity's own shape sits with the builder that produces it. A
 * re-reading of the legacy at a new vintage revises all of them as a set.
 */

type ExpenseReportStatus = "Active" | "Approved" | "FundsReceived" | "Pending";

interface ExpensePeriod {
  year: number;
  month: number;
}

interface PaginatedResponse<T> {
  data: T[];
  pagination: {
    currentPage: number;
    itemCount: number;
    itemsPerPage: number;
    totalItems?: number;
    totalPages?: number;
  };
}

function period(year: number, month: number): ExpensePeriod {
  return { year, month };
}

const COMPANY_NAMES = {
  pendingClean: "Kobenhavn Logistik A/S",
  approved: "Vestjysk Transport ApS",
  activeClean: "Fyn Energi A/S",
} as const;

function randomId(): number {
  return 1_000_000 + Math.floor(Math.random() * 9_000_000);
}

export { COMPANY_NAMES, period, randomId };
export type { ExpensePeriod, ExpenseReportStatus, PaginatedResponse };
